import { create } from 'zustand';

interface BottomBannerStore {
  inactivityWarningVisible: boolean;
  setInactivityWarningVisible: (visible: boolean) => void;
}

export const useBottomBannerStore = create<BottomBannerStore>((set) => ({
  inactivityWarningVisible: false,
  setInactivityWarningVisible: (inactivityWarningVisible) => set({ inactivityWarningVisible }),
}));
